var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#fff"
    },
    width: 512,
    height: 341.337,
    y: 85.331
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#d80027"
    },
    d: "M318.33,255.994c0,15.583-27.906,54.539-62.33,54.539s-62.33-38.957-62.33-54.539 c0-34.424,27.906-62.33,62.33-62.33S318.33,221.57,318.33,255.994z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0052b4"
    },
    d: "M318.33,255.994c0,34.424-27.906,62.33-62.33,62.33s-62.33-27.906-62.33-62.33"
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.374,
    height: 15.582,
    x: 324.205,
    y: 300.55,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -119.6501 327.8224)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 23.374,
    height: 15.582,
    x: 296.657,
    y: 328.085,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -147.1889 316.408)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 23.374,
    height: 15.582,
    x: 357.26,
    y: 333.586,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -133.3277 360.8719)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 23.374,
    height: 15.582,
    x: 329.712,
    y: 361.143,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -160.8823 349.464)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 23.374,
    height: 15.582,
    x: 340.732,
    y: 317.068,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -126.4889 344.3472)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 23.374,
    height: 15.582,
    x: 313.185,
    y: 344.614,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -154.0356 332.936)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 62.33,
    height: 15.582,
    x: 307.483,
    y: 165.555,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 455.5344 535.3814)"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 23.374,
    height: 15.581,
    x: 296.656,
    y: 168.315,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 401.8486 518.6624)"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 23.374,
    height: 15.581,
    x: 324.193,
    y: 195.864,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 429.3763 585.1636)"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 23.374,
    height: 15.582,
    x: 329.693,
    y: 135.257,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 481.6206 485.591)"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 23.374,
    height: 15.582,
    x: 357.252,
    y: 162.807,
    transform: "matrix(-0.7071 -0.7071 0.7071 -0.7071 509.1863 552.108)"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 62.33,
    height: 15.582,
    x: 125.671,
    y: 347.369,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 297.0721 -6.8758)"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 23.374,
    height: 15.581,
    x: 175.435,
    y: 344.62,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 303.9983 -29.0962)"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 23.374,
    height: 15.582,
    x: 147.898,
    y: 317.072,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 276.4547 -17.6934)"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 62.33,
    height: 15.582,
    x: 158.724,
    y: 314.322,
    transform: "matrix(0.7071 0.7071 -0.7071 0.7071 283.386 -39.9269)"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 62.33,
    height: 15.582,
    x: 125.672,
    y: 149.023,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 378.6212 156.7987)"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 62.33,
    height: 15.582,
    x: 142.182,
    y: 165.56,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 418.4998 173.3536)"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 62.33,
    height: 15.581,
    x: 158.712,
    y: 182.089,
    transform: "matrix(-0.7071 0.7071 -0.7071 -0.7071 458.4043 189.8812)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKor);
export default __webpack_public_path__ + "static/media/kor.460521c9345cdd03f0869d2d60e2f6a5.svg";
export { ForwardRef as ReactComponent };